import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { TileLayer } from 'react-leaflet';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_provider_config } from 'shared/map/model/selectors';
import { select_ui_settings } from 'console/redux/settings-actions';
import { removeNulls } from 'utils';
function createTileLayerFromSpec(attribution, layer_spec, zIndex, key) {
    const { url, ...options } = layer_spec;
    if (typeof options == 'object') {
        for (const [name, value] of Object.entries(options)) {
            if (typeof value == 'object' && '_eval' in value) {
                options[name] = eval(`(${value._eval})`);
            }
        }
    }
    return (_jsx(TileLayer, { url: url, attribution: attribution, zIndex: zIndex, ...options }, key));
}
export const CustomTileLayers = memo(function CustomTileLayers() {
    //Запрашиваем всех провайдеров карт, которые нам доступны (файлик map-providers.yml)
    const { providers } = useAppSelector(select_provider_config);
    const chosen_provider = useAppSelector((state) => select_ui_settings(state).map?.provider ?? 'yandex');
    const map_type = useAppSelector((state) => select_ui_settings(state).map?.type ?? 'street');
    const show_traffic = useAppSelector((state) => select_ui_settings(state).map?.traffic ?? false);
    return (_jsx(UnconnectedCustomTileLayers, { providers: providers, chosen_provider: chosen_provider, map_type: map_type, show_traffic: show_traffic }));
});
export const UnconnectedCustomTileLayers = memo(function UnconnectedCustomTileLayers(props) {
    const { providers, chosen_provider, map_type, show_traffic } = props;
    //Ищем выбранного нами провайдера из всех провайдеров
    const current_provider = useMemo(() => providers.find((prov) => prov.id === chosen_provider), [chosen_provider, providers]);
    //Берём всё, что лежит в соответствующем типе
    const type_config_layers = useMemo(() => {
        if (current_provider == null) {
            return [];
        }
        return (current_provider.types[map_type]?.layers ??
            current_provider.types['street'].layers);
    }, [current_provider, map_type]);
    if (current_provider == null) {
        return null;
    }
    // Ключ такой сложный, чтобы обойти багу в Leaflet
    // - не пересчитывает options при смене типа провайдера
    return (_jsxs(_Fragment, { children: [removeNulls(type_config_layers.map((layer, i) => createTileLayerFromSpec(current_provider.name, layer, 1, i + chosen_provider + map_type))), show_traffic &&
                current_provider.traffic_layer != null &&
                createTileLayerFromSpec(current_provider.name, current_provider.traffic_layer, 2, chosen_provider + 'traffic')] }));
});
